import { GlTooltipDirective, GlButton, GlModal, GlSearchBoxByType, GlSkeletonLoader, GlTruncate, GlDisclosureDropdown, GlDisclosureDropdownGroup } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import fuzzaldrinPlus from 'fuzzaldrin-plus';
import { uniqueId } from 'lodash-es';
import modalKeyboardNavigationMixin from '~/vue_shared/mixins/modal_keyboard_navigation_mixin';
import { getDerivedMergeRequestInformation } from '~/diffs/utils/merge_request';
import { InternalEvents } from '../../../tracking/index.js?vue3';
import savedRepliesQuery from 'ee_else_ce/vue_shared/components/markdown/saved_replies.query.graphql';
import { TRACKING_SAVED_REPLIES_USE, TRACKING_SAVED_REPLIES_USE_IN_MR, TRACKING_SAVED_REPLIES_USE_IN_OTHER, COMMENT_TEMPLATES_KEYS, COMMENT_TEMPLATES_TITLES } from 'ee_else_ce/vue_shared/components/markdown/constants';
export default {
    name: 'CommentTemplatesModal',
    apollo: {
        savedReplies: {
            query: savedRepliesQuery,
            manual: true,
            result ({ data, loading }) {
                if (!loading) {
                    this.savedReplies = data;
                }
            },
            variables () {
                const groupPath = document.body.dataset.groupFullPath;
                const projectPath = document.body.dataset.projectFullPath;
                return {
                    groupPath,
                    hideGroup: !groupPath,
                    projectPath,
                    hideProject: !projectPath
                };
            },
            skip () {
                return !this.shouldFetchCommentTemplates;
            }
        }
    },
    components: {
        GlButton,
        GlModal,
        GlSearchBoxByType,
        GlSkeletonLoader,
        GlTruncate,
        GlDisclosureDropdown,
        GlDisclosureDropdownGroup
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        InternalEvents.mixin(),
        modalKeyboardNavigationMixin
    ],
    props: {
        newCommentTemplatePaths: {
            type: Array,
            required: true
        }
    },
    emits: [
        'select'
    ],
    data () {
        return {
            shouldFetchCommentTemplates: false,
            savedReplies: {},
            commentTemplateSearch: ''
        };
    },
    computed: {
        allSavedReplies () {
            return COMMENT_TEMPLATES_KEYS.map((key)=>({
                    name: COMMENT_TEMPLATES_TITLES[key],
                    items: (this.savedReplies[key]?.savedReplies?.nodes || []).map((r)=>({
                            value: r.id,
                            text: r.name,
                            content: r.content
                        }))
                }));
        },
        filteredSavedReplies () {
            let savedReplies = this.allSavedReplies;
            if (this.commentTemplateSearch) {
                savedReplies = savedReplies.map((group)=>({
                        ...group,
                        items: fuzzaldrinPlus.filter(group.items, this.commentTemplateSearch, {
                            key: [
                                'text'
                            ]
                        })
                    })).filter(({ items })=>items.length);
            }
            return savedReplies.filter(({ items })=>items.length);
        },
        modalId () {
            return uniqueId('insert-comment-template-modal-');
        }
    },
    methods: {
        onSelect (savedReply) {
            const isInMr = Boolean(getDerivedMergeRequestInformation({
                endpoint: window.location
            }).id);
            this.$emit('select', savedReply.content);
            this.trackEvent(TRACKING_SAVED_REPLIES_USE);
            this.trackEvent(isInMr ? TRACKING_SAVED_REPLIES_USE_IN_MR : TRACKING_SAVED_REPLIES_USE_IN_OTHER);
            this.shouldFetchCommentTemplates = false;
        },
        toggleModal () {
            this.shouldFetchCommentTemplates = !this.shouldFetchCommentTemplates;
        }
    }
};
